/**
 * @generated SignedSource<<a46d839605fe1b17b04fb0b5db579df6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type HiringIntelligenceQuery$variables = {
  locationId: number;
  terms?: string | null;
};
export type HiringIntelligenceQuery$data = {
  readonly viewer: {
    readonly hiringIntel: {
      readonly avgCandidateSubmittalTime: number | null;
      readonly avgLengthOfAssignment: number | null;
      readonly candidatePool: number | null;
      readonly countryId: string | null;
      readonly difficultyLabel: string | null;
      readonly hiringDifficulty: number | null;
      readonly nationalAvgCandidateSubmittalTime: number | null;
      readonly nationalCandidatePool: number | null;
    } | null;
  } | null;
};
export type HiringIntelligenceQuery = {
  response: HiringIntelligenceQuery$data;
  variables: HiringIntelligenceQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "locationId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "terms"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "Viewer",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "locationId",
            "variableName": "locationId"
          },
          {
            "kind": "Variable",
            "name": "terms",
            "variableName": "terms"
          }
        ],
        "concreteType": "HiringIntelResponse",
        "kind": "LinkedField",
        "name": "hiringIntel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countryId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "avgLengthOfAssignment",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "avgCandidateSubmittalTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nationalAvgCandidateSubmittalTime",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "candidatePool",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nationalCandidatePool",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hiringDifficulty",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "difficultyLabel",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "HiringIntelligenceQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HiringIntelligenceQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5005db3fe47bb677a50a967cec8f9380",
    "id": null,
    "metadata": {},
    "name": "HiringIntelligenceQuery",
    "operationKind": "query",
    "text": "query HiringIntelligenceQuery(\n  $locationId: Int!\n  $terms: String\n) {\n  viewer {\n    hiringIntel(locationId: $locationId, terms: $terms) {\n      countryId\n      avgLengthOfAssignment\n      avgCandidateSubmittalTime\n      nationalAvgCandidateSubmittalTime\n      candidatePool\n      nationalCandidatePool\n      hiringDifficulty\n      difficultyLabel\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "fafbb951835bcf39e82cd2ad438493e0";

export default node;
